var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import RouteAnalyticsWrapper from 'components/common/route-analytics-wrapper/RouteAnalyticsWrapper';
import React from 'react';
export var wrapRouteWithAnalytics = function (route) {
    var component = route.component;
    if (!route.data) {
        return route;
    }
    var OriginalComponent = component;
    var aaData = route.data;
    var WrappedComponent = function (props) { return (<RouteAnalyticsWrapper aaData={aaData}>
      <OriginalComponent {...props}/>
    </RouteAnalyticsWrapper>); };
    WrappedComponent.displayName = 'RouteAnalyticsWrapped';
    // Strip data so withLocationChangeAnalytics (library HOC in createRoute) does not
    // fire a duplicate newPage — useRouteAnalytics inside RouteAnalyticsWrapper owns tracking.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _data = route.data, routeWithoutData = __rest(route, ["data"]);
    return __assign(__assign({}, routeWithoutData), { component: WrappedComponent });
};
